export default "__VITE_PUBLIC_ASSET__d6ae652e__"